module.exports = __webpack_public_path__ + "static/media/21.e180b6ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/21.jpg
// module id = 956
// module chunks = 0